<template>
    <div class="blackBackground labelComponentWrap">
        <div class="lavelTabNavToggle">
            <span class="backArrowIcon" id="close" @click="viewClose('someStatus')">
                <!-- <img :src='WhiteDownArrow' alt="Back Arrow" /> -->
            </span>
            <!-- <div class="arrowSpace"></div> -->
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'richlevel' }"
                        @click="activateTab('richlevel')" data-toggle="tab" href="#richlevel" role="tab">Rich Level
                    </div>
                </li>
                <li class="nav-item">
                    <div class="nav-link" :class="{ 'active': activeTab === 'charmlevel' }"
                        @click="activateTab('charmlevel')" data-toggle="tab" href="#charmlevel" role="tab">Charm Level
                    </div>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'richlevel' }" id="richlevel" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedRichLevel">
                    <Richlevel />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'charmlevel' }" id="charmlevel" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedCharmLevel">
                    <Charmlevel />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import WhiteDownArrow from '../../assets/images/white-downArrow.png'
import Richlevel from './RichLevel.vue'
import Charmlevel from './CharmLevel.vue'
export default {
    name: 'LevelComponent',
    components: {
        Richlevel,
        Charmlevel
    },
    data() {
        return {
            activeTab: 'richlevel',
            // WhiteDownArrow: WhiteDownArrow,
            isLoadedRichLevel: false,
            isLoadedCharmLevel: false
        };
    },
    mounted() {
        this.checkURLParams();
        // this.isLoadedRichLevel = true
    },
    methods: {
        activateTab(tabId) {
            this.activeTab = tabId;
            if(tabId === 'richlevel' && !this.isLoadedRichLevel) {
                this.isLoadedRichLevel = true
            }
            if(tabId === 'charmlevel' && !this.isLoadedCharmLevel) {
                this.isLoadedCharmLevel = true
            }
        },

        checkURLParams() {
            const leveltype = this.$route.params.leveltype;
            if (leveltype === '0') {
                this.activeTab = 'richlevel';
                this.isLoadedRichLevel = true
                this.isLoadedCharmLevel = false

            } else if (leveltype === '1') {
                this.activeTab = 'charmlevel';
                this.isLoadedRichLevel = false
                this.isLoadedCharmLevel = true
            }
        },
        // Close Webview on back arrow click
        // viewClose(status = '') {
        //     if (window.navigator.userAgent.indexOf("Android") > -1) {
        //         Android.viewClose(status);
        //     }
        // }

        viewClose(status) {
            if (window.Android && typeof Android.viewClose === "function") {
                Android.viewClose(status);
            } // iOS interface via messageHandlers
            else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.viewClose) {
                window.webkit.messageHandlers.viewClose.postMessage({ status });
            } else {
                window.parent.postMessage({ action: "closePopup", status }, "*");
            }
        }
    }
}
</script>